import React from 'react'
import ModalPopup from '../common/ModalPopup'

export const FirstOrderMessage = ({
  updatingModal,
  updateModalStart,
  email
}) => (
  <div className="first-order">
    <div className="row center-xs">
      <div className="col-xs">
        <div className="col middle-xs firstOrder">
          <i className="icon-check-circle success" /> You will receive a
          notification when your food arrives
        </div>
        <p className="firstOrderEmail">
          An order confirmation has been sent to {email}.
        </p>
        <div className="preferMobile">Prefer Mobile?</div>
        <p className="preferMobileText">
          Download the Foodsby app to get a notification sent to your phone when
          your food arrives.
        </p>
      </div>
    </div>
    <div className="row center-xs">
      <div className="col-xs">
        <a
          href="https://itunes.apple.com/us/app/foodsby/id875062433?mt=8"
          className="app-icon"
          style={{ margin: '15px 6px 20px' }}
        >
          <img
            height="42"
            width="140"
            src="/images/icon-app-store.png"
            alt="Get the Foodsby app on the App Store"
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.foodsby.consumerApp&amp;hl=en"
          className="app-icon"
        >
          <img
            height="42"
            width="140"
            src="/images/icon-google-play.png"
            alt="Get the Foodsby app on Google Play"
          />
        </a>
      </div>
    </div>
    <div className="row center-xs">
      <div className="col-xs">
        <button
          type="submit"
          className="link"
          onClick={() => updateModalStart({ hidePostOrderModal: true })}
          disabled={updatingModal}
        >
          Don't remind me again
        </button>
      </div>
    </div>
  </div>
)

export const FirstOrderModal = ({ updatingModal, updateModalStart, email }) => (
  <ModalPopup>
    <FirstOrderMessage
      updatingModal={updatingModal}
      updateModalStart={updateModalStart}
      email={email}
    />
  </ModalPopup>
)

export default FirstOrderModal
